import { defineComponent as _defineComponent } from 'vue'
import { reactive, inject, watch } from "vue";
import { ReplyPostStore, isValidReplyPostStoreKey } from "@/store/communityTalk/replyPostStore";
import PostMedia from "../PostMedia.vue";
import { PostMediaViewModel } from "@/viewModels/communityTalk/postMediaViewModel";
import { isValidCommunityTalkStoreKey } from "@/store/communityTalk/communityTalkStore";

interface State {
	/**
	 * リプライ投稿: メディア。
	 */
	postMediaViewModels: PostMediaViewModel[];
}

// reactiveな変数宣言
interface Emits {
	// 画像・動画の投稿が開始されたイベント
	(e: "on-start-post-process"): void;
	// 画像・動画の投稿が完了したイベント
	(e: "on-end-post-process"): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: {
		type: String,
		required: true,
	},
	/**
	 * ReplyPostStoreのInject用キー。
	 */
	replyPostStoreKey: {
		type: String,
		required: true,
	},
	/**
	 * 入力欄を無効化するかどうか。
	 */
	disabled: {
		type: Boolean,
		required: false,
		default: false,
	},
},
  emits: ["on-start-post-process", "on-end-post-process"],
  setup(__props, { expose, emit: emits }: { emit: ({
	// 画像・動画の投稿が開始されたイベント
	(e: "on-start-post-process"): void;
	// 画像・動画の投稿が完了したイベント
	(e: "on-end-post-process"): void;
}), expose: any, slots: any, attrs: any }) {
  expose()

const props = __props
/**
 * リプライ投稿 > リプライ投稿メディア。
 */



// Storeの初期化処理
if (!isValidCommunityTalkStoreKey(props.communityTalkStoreKey) || !isValidReplyPostStoreKey(props.replyPostStoreKey)) {
	// なんらかの原因でInjectKeyにエラーが発生していた場合は強制終了
	throw new Error(`InjectKeyにエラーが発生しました。${props.communityTalkStoreKey.toString()}, ${props.replyPostStoreKey.toString()}`);
}
const replyPostStore = inject(props.replyPostStoreKey) as ReplyPostStore;

const state = reactive<State>({
	postMediaViewModels: replyPostStore.getPostMediaViewModels(),
});

// Emits


// メディア投稿完了時の処理
const onSuccessUploadMedias = (viewModels: PostMediaViewModel[]): void => {
	replyPostStore.setPostMediaViewModels(viewModels);
};

// メディアリセット時の処理
const onResetMedias = (): void => {
	replyPostStore.setPostMediaViewModels([]);
};

/**
 * 投稿内容が他コンポーネント等から変更された場合、変更を反映する。
 */
watch(
	() => replyPostStore.getPostMediaViewModels(),
	(postMediaViewModels) => {
		state.postMediaViewModels = postMediaViewModels;
	}
);

// 画像・動画投稿開始イベント検知処理
const onStartPostProcess = (): void => {
	emits("on-start-post-process");
};
// 画像・動画投稿終了イベント検知処理
const onEndPostProcess = (): void => {
	emits("on-end-post-process");
};

const __returned__ = { props, replyPostStore, state, emits, onSuccessUploadMedias, onResetMedias, onStartPostProcess, onEndPostProcess, PostMedia }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})